/** O canvas está vazio — não há dado a disputar espaço com a tela. */
export function canvasVazio (canvasType: string): boolean {
  return canvasType === 'empty'
}

/**
 * N11 — o que um turno de PROSA pode varrer do painel.
 *
 * Prosa chega sempre com `canvas: empty` ("esta resposta não produz painel"),
 * e isso apagava a tabela que a pessoa acabara de pedir. Mas nem tudo no painel
 * merece sobreviver: um cartão de FALHA é aviso de um turno que já passou, e
 * deixá-lo na tela depois de um turno bem-sucedido é pior que limpá-lo — a
 * pessoa retentou, funcionou, e continuaria olhando para o erro.
 *
 * A régua é essa: o painel guarda o que a pessoa PEDIU (dado, prévia,
 * formulário em curso, oferta de tela, a aba de políticas de IA) e descarta o que apenas relatou um
 * desfecho ruim.
 */
const CANVAS_DESCARTAVEL = new Set(['empty', 'error', 'denied', 'uncertain'])

export function canvasDescartavelPorProsa (canvasType: string): boolean {
  return CANVAS_DESCARTAVEL.has(canvasType)
}
